// 역할
exports.Role = {
  A: "A", // 개설자
  B: "B", // 운영자
  C: "C", // 강의자
  D: "D", // 회원
  ALL: "ALL", // 모든 멤버
};

/**
 * 권한
 */
exports.Authority = {
  // campus
  CAMPUS_SUPER_MANAGE: "CAMPUS_SUPER_MANAGE",
  // product
  PRODUCT_SUPER_MANAGE: "PRODUCT_SUPER_MANAGE",
  PRODUCT_CREATE: "PRODUCT_CREATE",
  // class
  CLASS_SUPER_MANAGE: "CLASS_SUPER_MANAGE",
  CLASS_CREATE: "CLASS_CREATE",
  // course
  COURSE_CREATE: "COURSE_CREATE",
  COURSE_SUPER_MANAGE: "COURSE_SUPER_MANAGE",
  // post
  POST_SUPER_MANAGE: "POST_SUPER_MANAGE",
  POST_CREATE: "POST_CREATE",
  POST_NOTICE: "POST_NOTICE",
  //community
  COMMUNITY_SUPER_MANAGE: "COMMUNITY_SUPER_MANAGE",
};

/**
 * 상태
 */
// Campus Members Status
exports.MemberStatus = {
  JOIN: "JOIN",
  REQUEST: "REQUEST",
  RETRY_REQUEST: "RETRY_REQUEST",
  REJECT: "REJECT",
  CANCEL: "CANCEL",
  DEL: "DEL",
  PAY_REQUEST: "PAY_REQUEST",
  INVITE: "INVITE",
};

// Campus Members ChangeType
exports.MemberChangeType = {
  INVITE_STAFF: "INVITE_STAFF",
  JOIN_STAFF: "JOIN_STAFF",
  MODIFY_STAFF: "MODIFY_STAFF",
  DEL_STAFF: "DEL_STAFF",
  REQUEST: "REQUEST",
  CANCEL: "CANCEL",
  APPROVAL: "APPROVAL",
  REJECT: "REJECT",
  RETRY_REQUEST: "RETRY_REQUEST",
  MODIFY: "MODIFY",
  DEL: "DEL",
};

// Product Members ChangeType
exports.ProductMemberChangeType = {
  BASIC_JOIN_REQUEST: "BASIC_JOIN_REQUEST", // 운영 프로덕트 누구나 참여 or 신청(프로덕트 설정에 따름)
  BASIC_CANCEL: "BASIC_CANCEL", // 운영 프로덕트 참여 신청 취소
  BASIC_APPROVAL: "BASIC_APPROVAL", // 운영 프로덕트 참여 승인
  BASIC_REJECT: "BASIC_REJECT", // 운영 프로덕트 참여 거절
  BASIC_ADD: "BASIC_ADD", // 운영 프로덕트 회원 추가
  BASIC_REMOVE: "BASIC_REMOVE", // 운영 프로덕트 회원 제외
  MEMBER_MODIFY: "MEMBER_MODIFY", // 프로덕트 멤버의 수강종료일, 수료상태 변경
};

//Community Members ChangeType
exports.CommunityMemberChangeType = {
  BASIC_JOIN_REQUEST: "BASIC_JOIN_REQUEST", // 참여하기 or 참여신청하기
  BASIC_CANCEL: "BASIC_CANCEL", // 참여 신청 취소
  BASIC_APPROVAL: "BASIC_APPROVAL", // 참여 신청 승인
  BASIC_REJECT: "BASIC_REJECT", // 참여 신청 거절
  BASIC_ADD: "BASIC_ADD", // 회원 추가
  BASIC_REMOVE: "BASIC_REMOVE", // 회원 내보내기
};

exports.ApplicationMemberChangeType = {
  APPLICATION_JOIN: "APPLICATION_JOIN", // 신청하기 시 멤버로 참여
};

//Payment Status
exports.PaymentStatus = {
  PAID: "PAID", // 결제완료
  CANCEL_REQ: "CANCEL_REQ", // 결제취소요청
  CANCEL_PART: "CANCEL_PART", // 부분취소완료
  CANCEL_REJECT: "CANCEL_REJECT", // 취소거부
  CANCEL: "CANCEL", // 전체취소완료
  CANCEL_REVERT: "CANCEL_REVERT", //취소요청을 취소, PAID상태로 원복
  CANCELLATIONS: "CANCELLATIONS", // CANCEL, CANCEL_PART, CANCEL_REJECT
  PAY_CANCEL: "PAY_CANCEL", // PAY_REVERT, PAY_REJECT
  PAY_REQUEST: "PAY_REQUEST", //결제요청(기타, 가상)
  PAY_REJECT: "PAY_REJECT", //결제 거절(기타)
  PAY_REVERT: "PAY_REVERT", //결제 요청 취소 (기타, 가상)
  ETC_REQUEST_REVERT: "ETC_REQUEST_REVERT", // 기타결제 승인 요청 취소
  ETC_REQUEST_REJECT: "ETC_REQUEST_REJECT", // 기타결제 승인 거절
  ETC_REQUEST_APPROVAL: "ETC_REQUEST_APPROVAL", // 기타결제 승인
  ETC_CANCEL: "ETC_CANCEL", // 기타결제 취소
  V_BANK_CANCEL: "V_BANK_CANCEL", // 가상계좌 결제 취소
  V_BANK_CANCEL_PART: "V_BANK_CANCEL_PART", // 가상계좌 결제 부분 취소
  V_BANK_CANCEL_REQ: "V_BANK_CANCEL_REQ", // 가상계좌 결제 취소 요청
  REFUND_CANCEL: "REFUND_CANCEL", // 환불 취소
  REFUND: "REFUND", // 환불 완료
};

exports.ProgressStatus = {
  NONE: "NONE",
  NONE_FORCE: "NONE_FORCE",
  COMPLETE: "COMPLETE",
  COMPLETE_FORCE: "COMPLETE_FORCE",
  PROGRESS: "PROGRESS",
  HOLD: "HOLD",
  CLOSE: "CLOSE",
  CONDITION: "CONDITION",
  EXCEED: "EXCEED",
};

//Payment Way
exports.PaymentWay = {
  NONE: "NONE", //0월 결제 내역
  CARD: "CARD",
  CASH: "CASH",
  NAVER: "NAVER",
  KAKAO: "KAKAO",
  BANK: "BANK", //실시간 계좌이체
  V_BANK: "V_BANK", //가상계좌
  ETC: "ETC", //기타 결제
};

//가상계좌 환불은행코드
exports.BankCdVBankRefund = {
  B279: "DB금융투자(구,동부증권)",
  B218: "KB증권(현대)",
  BK81: "KEB하나은행",
  B247: "NH투자증권(구,우리투자증권)",
  BK23: "SC제일은행",
  B266: "SK증권",
  BK34: "광주은행",
  BK39: "경남은행",
  BK04: "국민은행",
  BK03: "기업은행",
  BK11: "농협",
  BK12: "단위농협",
  BK31: "대구은행",
  B267: "대신증권",
  B238: "미래에셋대우",
  B287: "메리츠",
  BK32: "부산은행",
  BK64: "산림조합",
  BK02: "산업은행",
  B240: "삼성증권",
  BK07: "수협",
  B291: "신영증권",
  BK88: "신한은행",
  B278: "신한금융투자",
  BK48: "신협",
  BK45: "새마을금고",
  BK20: "우리은행",
  BK71: "우체국",
  B209: "유안타증권(구,동양증권)",
  B280: "유진투자증권",
  BK37: "전북은행",
  BK35: "제주은행",
  BK90: "카카오뱅크",
  BK89: "케이뱅크",
  BK92: "토스뱅크",
  B270: "하나증권",
  B262: "하이투자증권",
  B243: "한국투자증권",
  BK27: "한국시티은행",
  B269: "한화증권",
  B263: "현대차증권",
};
